module.exports = __webpack_public_path__ + "img/authorize2-eg.508c0e34.jpg";